import React from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import Col from '../../../elements/Col';
import Row from '../../../elements/Row';
import Box from '../../../elements/Box';

const styles = {
  header: {
    height: '25px',
    marginBottom: '0.5rem',
  },
  selectorControls: {
    height: '40px',
    marginBottom: '0.5rem',
  },
  carousel: {
    height: '300px',
    marginBottom: '0.5rem',
  },
  centerElement: {
    marginLeft: '25%',
  },
  dots: {
    height: '20px',
    marginBottom: '0.25rem',
  },
  disclaimer: {
    height: '20px',
    marginTop: '0.25rem',
  },
};

const SkeletonFaresCarouselBackgroundImageMobile = (props) => {
  const [className, style] = useStyles(props);
  const { header, selectorControls, carousel, centerElement, dots, disclaimer } = styles;
  return (
    <Box
      className={`${className} fr-skeleton`}
      style={style}
      dataTestId="skeletonFaresCarouselBackgroundImageMobile"
    >
      <Row gutters>
        <Col>
          <Box className="fr-skeleton-element" style={header} />
        </Col>
      </Row>
      <Row gutters>
        <Col>
          <Box className="fr-skeleton-element" style={selectorControls} />
        </Col>
      </Row>
      <Row gutters>
        <Col>
          <Box className="fr-skeleton-element" style={selectorControls} />
        </Col>
      </Row>
      <Row gutters>
        <Col>
          <Box className="fr-skeleton-element" style={selectorControls} />
        </Col>
      </Row>
      <Row gutters>
        <Col>
          <Box className="fr-skeleton-element" style={carousel} />
        </Col>
      </Row>
      <Row gutters>
        <Col xs="6" style={centerElement}>
          <Box className="fr-skeleton-element" style={dots} />
        </Col>
      </Row>
      <Row gutters>
        <Col xs="12">
          <Box className="fr-skeleton-element" style={disclaimer} />
        </Col>
      </Row>
    </Box>
  );
};

SkeletonFaresCarouselBackgroundImageMobile.componentName =
  'SkeletonFaresCarouselBackgroundImageMobile';

export default SkeletonFaresCarouselBackgroundImageMobile;
